const propertyTypes = (propertyTypes = [], action) => {
  switch (action.type) {
    case 'FETCH_ALL_PROPERTY_TYPES':
      return action.payload
    default:
      return propertyTypes
  }
}
export default propertyTypes
